import { render, staticRenderFns } from "./profile-individual.vue?vue&type=template&id=0f0c5afe&scoped=true"
import script from "./profile-individual.vue?vue&type=script&lang=js"
export * from "./profile-individual.vue?vue&type=script&lang=js"
import style0 from "./profile-individual.vue?vue&type=style&index=0&id=0f0c5afe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0c5afe",
  null
  
)

export default component.exports